import { render, staticRenderFns } from "./MemClassify.vue?vue&type=template&id=70ff2652&scoped=true"
import script from "./MemClassify.vue?vue&type=script&lang=js"
export * from "./MemClassify.vue?vue&type=script&lang=js"
import style0 from "./MemClassify.vue?vue&type=style&index=0&id=70ff2652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff2652",
  null
  
)

export default component.exports